import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { MessageCircle, Twitter, Facebook, Copy, Check } from "lucide-react";
import { toast } from "sonner";
import { formatIDR } from "../lib/api";

export default function ShareDialog({ product, open, onOpenChange }) {
    const [copied, setCopied] = useState(false);
    const productUrl = `${window.location.origin}/produk/${product.id}`;
    const shareText = `${product.title} — ${formatIDR(product.price)} | karya daur ulang kertas di Acture.id`;

    const options = [
        {
            id: "whatsapp",
            label: "WhatsApp",
            icon: MessageCircle,
            href: `https://wa.me/?text=${encodeURIComponent(`${shareText}\n${productUrl}`)}`,
            cls: "bg-brand-forestLight text-brand-forest",
        },
        {
            id: "x",
            label: "X / Twitter",
            icon: Twitter,
            href: `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}&url=${encodeURIComponent(productUrl)}`,
            cls: "bg-brand-cream text-brand-ink",
        },
        {
            id: "facebook",
            label: "Facebook",
            icon: Facebook,
            href: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(productUrl)}`,
            cls: "bg-brand-cream text-brand-ink",
        },
    ];

    const copy = async () => {
        try {
            await navigator.clipboard.writeText(productUrl);
            setCopied(true);
            toast.success("Link karya dicopy!");
            setTimeout(() => setCopied(false), 2000);
        } catch {
            toast.error("Gagal copy link");
        }
    };

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="max-w-sm rounded-[26px] border-2 border-brand-ink bg-white p-7 gap-0" data-testid="share-dialog">
                <DialogHeader>
                    <DialogTitle className="font-display text-xl font-extrabold text-left">Bagikan Karya</DialogTitle>
                    <DialogDescription className="text-sm text-brand-ink/60 text-left mt-1 truncate">{product.title}</DialogDescription>
                </DialogHeader>
                <div className="mt-5 flex flex-col gap-2.5">
                    {options.map((o) => (
                        <a
                            key={o.id}
                            data-testid={`share-option-${o.id}-${product.id}`}
                            href={o.href}
                            target="_blank"
                            rel="noreferrer"
                            className="flex items-center gap-3 px-4 py-3 rounded-2xl border-2 border-brand-ink bg-white hover:bg-brand-sunshine/40 transition-colors"
                        >
                            <span className={`grid place-items-center w-10 h-10 rounded-xl border-2 border-brand-ink ${o.cls}`}>
                                <o.icon className="w-5 h-5" strokeWidth={2.2} />
                            </span>
                            <span className="font-bold text-sm">{o.label}</span>
                        </a>
                    ))}
                    <button
                        data-testid={`share-copy-link-${product.id}`}
                        onClick={copy}
                        className="flex items-center gap-3 px-4 py-3 rounded-2xl border-2 border-brand-ink bg-white hover:bg-brand-sunshine/40 transition-colors text-left"
                    >
                        <span className="grid place-items-center w-10 h-10 rounded-xl border-2 border-brand-ink bg-brand-sunshine/70 text-brand-ink">
                            {copied ? <Check className="w-5 h-5" strokeWidth={2.4} /> : <Copy className="w-5 h-5" strokeWidth={2.2} />}
                        </span>
                        <span className="font-bold text-sm">{copied ? "Link tercopy!" : "Copy Link"}</span>
                    </button>
                </div>
            </DialogContent>
        </Dialog>
    );
}
